[
  {"name":"Afghanistan","nameFr":"Afghanistan"},
  {"name":"Albania","nameFr":"Albanie"},
  {"name":"Algeria","nameFr":"Algérie"},
  {"name":"Andorra","nameFr":"Andorre"},
  {"name":"Angola","nameFr":"Angola"},
  {"name":"Antigua and Barbuda","nameFr":"Antigua-et-Barbuda"},
  {"name":"Argentina","nameFr":"Argentine"},
  {"name":"Armenia","nameFr":"Arménie"},
  {"name":"Australia","nameFr":"Australie"},
  {"name":"Austria","nameFr":"Autriche"},
  {"name":"Azerbaijan","nameFr":"Azerbaïdjan"},
  {"name":"Bahamas","nameFr":"Bahamas"},
  {"name":"Bahrain","nameFr":"Bahreïn"},
  {"name":"Bangladesh","nameFr":"Bangladesh"},
  {"name":"Barbados","nameFr":"Barbade"},
  {"name":"Belarus","nameFr":"Biélorussie"},
  {"name":"Belgium","nameFr":"Belgique"},
  {"name":"Belize","nameFr":"Belize"},
  {"name":"Benin","nameFr":"Bénin"},
  {"name":"Bhutan","nameFr":"Bhoutan"},
  {"name":"Bolivia","nameFr":"Bolivie"},
  {"name":"Bosnia and Herzegovina","nameFr":"Bosnie-Herzégovine"},
  {"name":"Botswana","nameFr":"Botswana"},
  {"name":"Brazil","nameFr":"Brésil"},
  {"name":"Brunei","nameFr":"Brunéi"},
  {"name":"Bulgaria","nameFr":"Bulgarie"},
  {"name":"Burkina Faso","nameFr":"Burkina Faso"},
  {"name":"Burundi","nameFr":"Burundi"},
  {"name":"Cabo Verde","nameFr":"Cap-Vert"},
  {"name":"Cambodia","nameFr":"Cambodge"},
  {"name":"Cameroon","nameFr":"Cameroun"},
  {"name":"Canada","nameFr":"Canada"},
  {"name":"Central African Republic","nameFr":"République centrafricaine"},
  {"name":"Chad","nameFr":"Tchad"},
  {"name":"Chile","nameFr":"Chili"},
  {"name":"China","nameFr":"Chine"},
  {"name":"Colombia","nameFr":"Colombie"},
  {"name":"Comoros","nameFr":"Comores"},
  {"name":"Congo","nameFr":"Congo"},
  {"name":"Congo (DRC)","nameFr":"République démocratique du Congo"},
  {"name":"Costa Rica","nameFr":"Costa Rica"},
  {"name":"Côte d'Ivoire","nameFr":"Côte d'Ivoire"},
  {"name":"Croatia","nameFr":"Croatie"},
  {"name":"Cuba","nameFr":"Cuba"},
  {"name":"Cyprus","nameFr":"Chypre"},
  {"name":"Czechia","nameFr":"République tchèque"},
  {"name":"Denmark","nameFr":"Danemark"},
  {"name":"Djibouti","nameFr":"Djibouti"},
  {"name":"Dominica","nameFr":"Dominique"},
  {"name":"Dominican Republic","nameFr":"République dominicaine"},
  {"name":"Ecuador","nameFr":"Équateur"},
  {"name":"Egypt","nameFr":"Égypte"},
  {"name":"El Salvador","nameFr":"Salvador"},
  {"name":"Equatorial Guinea","nameFr":"Guinée équatoriale"},
  {"name":"Eritrea","nameFr":"Érythrée"},
  {"name":"Estonia","nameFr":"Estonie"},
  {"name":"Eswatini","nameFr":"Eswatini"},
  {"name":"Ethiopia","nameFr":"Éthiopie"},
  {"name":"Fiji","nameFr":"Fidji"},
  {"name":"Finland","nameFr":"Finlande"},
  {"name":"France","nameFr":"France"},
  {"name":"Gabon","nameFr":"Gabon"},
  {"name":"Gambia","nameFr":"Gambie"},
  {"name":"Georgia","nameFr":"Géorgie"},
  {"name":"Germany","nameFr":"Allemagne"},
  {"name":"Ghana","nameFr":"Ghana"},
  {"name":"Greece","nameFr":"Grèce"},
  {"name":"Grenada","nameFr":"Grenade"},
  {"name":"Guatemala","nameFr":"Guatemala"},
  {"name":"Guinea","nameFr":"Guinée"},
  {"name":"Guinea-Bissau","nameFr":"Guinée-Bissau"},
  {"name":"Guyana","nameFr":"Guyana"},
  {"name":"Haiti","nameFr":"Haïti"},
  {"name":"Honduras","nameFr":"Honduras"},
  {"name":"Hungary","nameFr":"Hongrie"},
  {"name":"Iceland","nameFr":"Islande"},
  {"name":"India","nameFr":"Inde"},
  {"name":"Indonesia","nameFr":"Indonésie"},
  {"name":"Iran","nameFr":"Iran"},
  {"name":"Iraq","nameFr":"Irak"},
  {"name":"Ireland","nameFr":"Irlande"},
  {"name":"Israel","nameFr":"Israël"},
  {"name":"Italy","nameFr":"Italie"},
  {"name":"Jamaica","nameFr":"Jamaïque"},
  {"name":"Japan","nameFr":"Japon"},
  {"name":"Jordan","nameFr":"Jordanie"},
  {"name":"Kazakhstan","nameFr":"Kazakhstan"},
  {"name":"Kenya","nameFr":"Kenya"},
  {"name":"Kiribati","nameFr":"Kiribati"},
  {"name":"Korea (North)","nameFr":"Corée du Nord"},
  {"name":"Korea (South)","nameFr":"Corée du Sud"},
  {"name":"Kuwait","nameFr":"Koweït"},
  {"name":"Kyrgyzstan","nameFr":"Kirghizistan"},
  {"name":"Laos","nameFr":"Laos"},
  {"name":"Latvia","nameFr":"Lettonie"},
  {"name":"Lebanon","nameFr":"Liban"},
  {"name":"Lesotho","nameFr":"Lesotho"},
  {"name":"Liberia","nameFr":"Libéria"},
  {"name":"Libya","nameFr":"Libye"},
  {"name":"Liechtenstein","nameFr":"Liechtenstein"},
  {"name":"Lithuania","nameFr":"Lituanie"},
  {"name":"Luxembourg","nameFr":"Luxembourg"},
  {"name":"Madagascar","nameFr":"Madagascar"},
  {"name":"Malawi","nameFr":"Malawi"},
  {"name":"Malaysia","nameFr":"Malaisie"},
  {"name":"Maldives","nameFr":"Maldives"},
  {"name":"Mali","nameFr":"Mali"},
  {"name":"Malta","nameFr":"Malte"},
  {"name":"Marshall Islands","nameFr":"Îles Marshall"},
  {"name":"Mauritania","nameFr":"Mauritanie"},
  {"name":"Mauritius","nameFr":"Maurice"},
  {"name":"Mexico","nameFr":"Mexique"},
  {"name":"Micronesia","nameFr":"Micronésie"},
  {"name":"Moldova","nameFr":"Moldavie"},
  {"name":"Monaco","nameFr":"Monaco"},
  {"name":"Mongolia","nameFr":"Mongolie"},
  {"name":"Montenegro","nameFr":"Monténégro"},
  {"name":"Morocco","nameFr":"Maroc"},
  {"name":"Mozambique","nameFr":"Mozambique"},
  {"name":"Myanmar","nameFr":"Myanmar"},
  {"name":"Namibia","nameFr":"Namibie"},
  {"name":"Nauru","nameFr":"Nauru"},
  {"name":"Nepal","nameFr":"Népal"},
  {"name":"Netherlands","nameFr":"Pays-Bas"},
  {"name":"New Zealand","nameFr":"Nouvelle-Zélande"},
  {"name":"Nicaragua","nameFr":"Nicaragua"},
  {"name":"Niger","nameFr":"Niger"},
  {"name":"Nigeria","nameFr":"Nigéria"},
  {"name":"North Macedonia","nameFr":"Macédoine du Nord"},
  {"name":"Norway","nameFr":"Norvège"},
  {"name":"Oman","nameFr":"Oman"},
  {"name":"Pakistan","nameFr":"Pakistan"},
  {"name":"Palau","nameFr":"Palaos"},
  {"name":"Palestine","nameFr":"Palestine"},
  {"name":"Panama","nameFr":"Panama"},
  {"name":"Papua New Guinea","nameFr":"Papouasie–Nouvelle-Guinée"},
  {"name":"Paraguay","nameFr":"Paraguay"},
  {"name":"Peru","nameFr":"Pérou"},
  {"name":"Philippines","nameFr":"Philippines"},
  {"name":"Poland","nameFr":"Pologne"},
  {"name":"Portugal","nameFr":"Portugal"},
  {"name":"Qatar","nameFr":"Qatar"},
  {"name":"Romania","nameFr":"Roumanie"},
  {"name":"Russia","nameFr":"Russie"},
  {"name":"Rwanda","nameFr":"Rwanda"},
  {"name":"Saint Kitts and Nevis","nameFr":"Saint-Christophe-et-Niévès"},
  {"name":"Saint Lucia","nameFr":"Sainte-Lucie"},
  {"name":"Saint Vincent and the Grenadines","nameFr":"Saint-Vincent-et-les-Grenadines"},
  {"name":"Samoa","nameFr":"Samoa"},
  {"name":"San Marino","nameFr":"Saint-Marin"},
  {"name":"Sao Tome and Principe","nameFr":"Sao Tomé-et-Principe"},
  {"name":"Saudi Arabia","nameFr":"Arabie saoudite"},
  {"name":"Senegal","nameFr":"Sénégal"},
  {"name":"Serbia","nameFr":"Serbie"},
  {"name":"Seychelles","nameFr":"Seychelles"},
  {"name":"Sierra Leone","nameFr":"Sierra Leone"},
  {"name":"Singapore","nameFr":"Singapour"},
  {"name":"Slovakia","nameFr":"Slovaquie"},
  {"name":"Slovenia","nameFr":"Slovénie"},
  {"name":"Solomon Islands","nameFr":"Îles Salomon"},
  {"name":"Somalia","nameFr":"Somalie"},
  {"name":"South Africa","nameFr":"Afrique du Sud"},
  {"name":"South Sudan","nameFr":"Soudan du Sud"},
  {"name":"Spain","nameFr":"Espagne"},
  {"name":"Sri Lanka","nameFr":"Sri Lanka"},
  {"name":"Sudan","nameFr":"Soudan"},
  {"name":"Suriname","nameFr":"Suriname"},
  {"name":"Sweden","nameFr":"Suède"},
  {"name":"Switzerland","nameFr":"Suisse"},
  {"name":"Syria","nameFr":"Syrie"},
  {"name":"Taiwan","nameFr":"Taïwan"},
  {"name":"Tajikistan","nameFr":"Tadjikistan"},
  {"name":"Tanzania","nameFr":"Tanzanie"},
  {"name":"Thailand","nameFr":"Thaïlande"},
  {"name":"Timor-Leste","nameFr":"Timor oriental"},
  {"name":"Togo","nameFr":"Togo"},
  {"name":"Tonga","nameFr":"Tonga"},
  {"name":"Trinidad and Tobago","nameFr":"Trinité-et-Tobago"},
  {"name":"Tunisia","nameFr":"Tunisie"},
  {"name":"Türkiye","nameFr":"Turquie"},
  {"name":"Turkmenistan","nameFr":"Turkménistan"},
  {"name":"Tuvalu","nameFr":"Tuvalu"},
  {"name":"Uganda","nameFr":"Ouganda"},
  {"name":"Ukraine","nameFr":"Ukraine"},
  {"name":"United Arab Emirates","nameFr":"Émirats arabes unis"},
  {"name":"United Kingdom","nameFr":"Royaume-Uni"},
  {"name":"United States","nameFr":"États-Unis"},
  {"name":"Uruguay","nameFr":"Uruguay"},
  {"name":"Uzbekistan","nameFr":"Ouzbékistan"},
  {"name":"Vanuatu","nameFr":"Vanuatu"},
  {"name":"Vatican City","nameFr":"Cité du Vatican"},
  {"name":"Venezuela","nameFr":"Venezuela"},
  {"name":"Vietnam","nameFr":"Viêt Nam"},
  {"name":"Yemen","nameFr":"Yémen"},
  {"name":"Zambia","nameFr":"Zambie"},
  {"name":"Zimbabwe","nameFr":"Zimbabwe"}
]
